export const MUTATION_REGISTER_SNAPSHOT_LISTENER = 'REGISTER_SNAPSHOT_LISTENER';
export const MUTATION_UNREGISTER_SNAPSHOT_LISTENER = 'UNREGISTER_SNAPSHOT_LISTENER';
